import { render } from "./ckediter.vue?vue&type=template&id=29c4fc36"
import script from "./ckediter.vue?vue&type=script&lang=js"
export * from "./ckediter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__